import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';

import { MessageComponent } from '@components/message/message.component';
import { MessageData, TypeToast } from '@models/messagedata';
import { ValidationResult } from '@models/validation-result';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(private snackBar: MatSnackBar) { }

  /**
   * @param data Mensagem do Toast
   * @returns
   */
  public showToast(data: MessageData): MatSnackBarRef<MessageComponent> {
    const config: MatSnackBarConfig = {
      panelClass: ['override-shared-componentes-message-custom-class'],
      data,
      duration: data.description == null || data.description?.length <= 100 ? 5000 : 10000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    };

    return this.snackBar.openFromComponent(MessageComponent, config);
  }

  public showToastErrorValidation(validationErros: ValidationResult): MatSnackBarRef<MessageComponent> {
    return this.showToast({
      message: validationErros.errors.length > 0 ? validationErros.errors[0].errorMessage : 'Ocorreu um erro',
      typeToast: TypeToast.ERROR
    });
  }

  public showToastError(error: string): MatSnackBarRef<MessageComponent> {
    return this.showToast({
      message: error,
      typeToast: TypeToast.ERROR,
      description: null
    });
  }


  public showToastSuccess(msg: string): MatSnackBarRef<MessageComponent> {
    return this.showToast({
      message: msg,
      typeToast: TypeToast.SUCCESS,
      description: null
    });
  }

  public showToastWarning(warningMessage: string): MatSnackBarRef<MessageComponent> {
    return this.showToast({
      message: warningMessage,
      typeToast: TypeToast.WARNING,
      description: null
    });
  }

  private getDuration(typeToast: TypeToast): number | null {
    return typeToast === TypeToast.SUCCESS ? 8000 : null;
  }
}
